var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0335 49.1888C31.8066 48.8294 31.6931 48.6497 31.6295 48.3725C31.5818 48.1643 31.5818 47.836 31.6295 47.6278C31.6931 47.3506 31.8066 47.1709 32.0335 46.8115C33.9092 43.8416 39.4923 36.3335 48.0007 36.3335C56.509 36.3335 62.0921 43.8416 63.9678 46.8115C64.1948 47.1709 64.3083 47.3506 64.3718 47.6278C64.4195 47.836 64.4195 48.1643 64.3718 48.3725C64.3083 48.6497 64.1948 48.8294 63.9678 49.1888C62.0921 52.1588 56.509 59.6668 48.0007 59.6668C39.4923 59.6668 33.9092 52.1588 32.0335 49.1888Z",
    stroke: "#FDB022",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0007 53.0002C50.7621 53.0002 53.0007 50.7616 53.0007 48.0002C53.0007 45.2387 50.7621 43.0002 48.0007 43.0002C45.2392 43.0002 43.0007 45.2387 43.0007 48.0002C43.0007 50.7616 45.2392 53.0002 48.0007 53.0002Z",
    stroke: "#FDB022",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#FFFAEB",
    strokeWidth: 14.2857
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi3);
export default __webpack_public_path__ + "static/media/fi3.447dbcc4cabcfd6821b63e3b8b78b9db.svg";
export { ForwardRef as ReactComponent };